import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getJobById, IJob } from 'wisestep-api';
import { WsSelectObj } from 'wisestep-base';

import { fetchBusinessUnits, getClientIdByClientName } from '../../helper';
import { useListingSettings } from '../../listing/hooks';
import JobPageParams from '../../types/JobPageParams';
import JobPostingForm from '../components/JobPostingForm';

const CloneJob = () => {
  const [job, setJob] = useState<IJob>({});
  const [isJobLoaded, setIsJobLoaded] = useState<boolean>(false);
  const [businessUnits, setBusinessUnits] = useState<WsSelectObj[]>([]);
  const { jobFieldSettings } = useListingSettings();
  const params = useParams<JobPageParams>();
  const jobId: string = params.jobId ?? '';
  const navigate = useNavigate();
  const goToJobsHomePage = () => navigate('/jobs');

  useEffect(() => {
    fetchBusinessUnits(setJob, setBusinessUnits);
  }, []);

  useEffect(() => {
    const cloneNewJob = async () => {
      setIsJobLoaded(false);
      const jobEntity = await getJobById(jobId);
      if (jobEntity.data?.clientId == null && jobEntity.data?.companyName) {
        jobEntity.data.clientId = await getClientIdByClientName(jobEntity.data?.companyName);
      }
      const newJob: IJob = {
        title: jobEntity.data.title,
        locations: jobEntity.data.locations,
        numberOfPositions: jobEntity.data.numberOfPositions,
        taxTerms: jobEntity.data.taxTerms,
        salaryCurrency: jobEntity.data.salaryCurrency,
        minimumSalary: jobEntity.data.minimumSalary,
        maximumSalary: jobEntity.data.maximumSalary,
        salaryTimeSpan: jobEntity.data.salaryTimeSpan,
        skills: jobEntity.data.skills,
        description: jobEntity.data.description,
        companyName: jobEntity.data.companyName,
        clientRecruiter: jobEntity.data.clientRecruiter,
        accountManagerName: jobEntity.data.accountManagerName,
        jobIndustryName: jobEntity.data.jobIndustryName,
        jobOccupation: jobEntity.data.jobOccupation,
        jobType: jobEntity.data.jobType,
        tags: jobEntity.data.tags,
        insights: jobEntity.data.insights,
        jobCategory: jobEntity.data.jobCategory,
        jobStatusType: jobEntity.data.jobStatusType,
        workplacePreference: jobEntity.data.remoteJob
          ? 'Remote'
          : jobEntity.data.workplacePreference,
        clientBillRateNew: jobEntity.data.clientBillRateNew,
        remoteJob: jobEntity.data.workplacePreference?.toLowerCase() == 'remote',
        businessUnit: jobEntity.data.businessUnit,
        clientJobCode: '',
        jobCode: '',
        id: '',
      };
      setJob(newJob);
      setIsJobLoaded(true);
    };
    cloneNewJob();
  }, [setJob, jobId]);

  return (
    <>
      {isJobLoaded && (
        <JobPostingForm
          jobEntity={job}
          jobFieldSettings={jobFieldSettings}
          onNavigateBack={goToJobsHomePage}
          businessUnits={businessUnits}
        />
      )}
    </>
  );
};

export default CloneJob;
